import { createUserApiClient } from "../lib/apiClient";

const api = createUserApiClient();

export const fetchUsers = () => api.get("/users");

// Superadmin-only: users for a specific organisation (cross-org read).
// queryKey is ["users", "organisation", organisationId].
export const fetchUsersByOrganisationId = ({ queryKey }) => {
  const organisationId = queryKey[2];
  return api.get(`/users/organisation/${organisationId}`);
};

export const fetchUser = ({ queryKey }) => {
  const userId = queryKey[1];
  return api.get(`/users/${userId}`);
};

export const createUser = (userData) => api.post("/users", userData);

export const updateUser = (userId, userData) =>
  api.put(`/users/${userId}`, userData);

export const deleteUser = (userId) => {
  if (userId === undefined) {
    return undefined;
  }
  return api.delete(`/users/${userId}`);
};

export const bulkImportUsers = (formData) =>
  api.post("/bulk-import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
